export default "__VITE_ASSET__Cts10wsj__"